/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'resources/less/themes/base/pages/standalone/about_us.less';

import 'APP_THEME/_common/selectboxit/index';

$(function() {
    var $form = $('.reseller-form');
    $form
        .find('select')
        .selectBoxIt({ autoWidth: false })
        .on('change', function() {
            $form
                .attr(
                    'action',
                    $(this)
                        .find('option')
                        .filter(':selected')
                        .val()
                )
                .find('button')
                .removeAttr('disabled');
        });
});
